import styled from 'styled-components';

export const CSSItemWrapper = styled.div`
    border-radius: ${(props) => props.theme.space.sm}px;
    padding: ${(props) => props.theme.space.sm}px;
    overflow: hidden;
    background-color: ${(props) => props.theme.color.grey1};
`;

export const CSSItem = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    i.icon-reorder {
        cursor: move;
    }
`;

export const CSSItemLabel = styled.div`
    flex: 1;
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CSSItemLabelWithEllipsis = styled.div`
    flex: 1;
    width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CSSItemIcon = styled.div<{ backgroundColor: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: ${(props) => props.backgroundColor};
`;

export const CSSListBorderBottom = styled.div`
    margin-bottom: ${(props) => props.theme.space.md}px 0px;
    border-bottom: 1px solid ${(props) => props.theme.color.grey1};
`;

export const CSSInlineInput = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;
export const CSSFlexInput = styled.div`
    flex: 1;
`;

export const CSSListItem = styled.div<{ isActive?: boolean }>`
    display: flex;
    flex-direction: row;
    gap: ${(props) => props.theme.space.sm}px;
    align-items: center;
    padding: ${(props) => props.theme.space.sm}px 0px;
    border-bottom: 1px solid ${(props) => props.theme.color.grey1};
    opacity: ${(props) => (props.isActive ? 1 : 0.4)};
    pointer-events: ${(props) => (props.isActive ? 'all' : 'none')};
`;

export const CSSAlertMessage = styled.div`
    display: flex;
    justify-content: center;
    border-radius: ${(props) => props.theme.space.md}px;
    padding: ${(props) => props.theme.space.md}px;
    margin-bottom: ${(props) => props.theme.space.md}px;
    color: ${(props) => props.theme.color.white};
    background-color: ${(props) => props.theme.color.orangeL15};
`;

export const CSSDisabled = styled.div<{ disabled: boolean }>`
    opacity: ${(props) => (props.disabled ? 0.4 : 1)};
    pointer-events: none;
`;
